import { Component, Input, OnInit, Pipe, PipeTransform, TemplateRef, ViewChild } from '@angular/core';
import { DocumentsService } from '../../../services/documents.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder} from '@angular/forms';
import { ModelList } from 'projects/core/src/include/modellist'
import { Globals } from 'projects/core/src/globals';
import { ToastMode } from 'projects/core/src/include/structures';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadService } from 'projects/core/src/lib/upload.service';

@Component({
  selector: 'app-fatturaelettronica',
  templateUrl: './fatturaelettronica.component.html',
  styleUrl: './fatturaelettronica.component.css'
})

export class FatturaelettronicaComponent extends ModelList<any> implements OnInit {
  
  
  @ViewChild("frame")
    frame;

  @ViewChild('uploadXMLModal')
    uploadXMLModal:TemplateRef<any>;
    uploadXMLModalRef;
    fileXMLToUpload: File = null;
   

  @Input()
   id_document:number=0;

  @Input()
    sdi_status:number=0;

  @Input()
    role_pa:boolean=false;

  @Input()
    id_type:number=0;

  url:string="";
  url_xml:string="";

  message=[];

  style1="Foglio_di_stile_fatturaordinaria_v1.2.1.xsl.xml";
  style2="FoglioStileAssoSoftware.xsl";
  style = this.style1;


  constructor(
    private fb1: UntypedFormBuilder,
    private modalService: NgbModal,
    private uploadService:UploadService,
    private documentsService:DocumentsService,
    public sanitizer:DomSanitizer,
    private httpClient:HttpClient
  ) {
    super(documentsService,fb1)
   }

  
  ngOnInit(): void {    

    if (Globals.parameters.get("documents").getParam("envoicestylesheet")==1) this.style=this.style1;
    if (Globals.parameters.get("documents").getParam("envoicestylesheet")==2) this.style=this.style2;
    
    this.updateStyle(this.style);  
    this.createXML();

    

  }


  updateStyle(s){
    this.style=s;
    this.documentsService.createXSL(this.id_document,s).subscribe((uri)=>{
      this.url=uri;
    });
  }

  close(){
    this['modalWindow'].close();
  }

  checkXML(){
    this.documentsService.checkXMLEInvoice([this.id_document]).subscribe((result)=>{
      if(result){
        try{
        this.message=JSON.parse(result[0]['sdi_message']);
        }
        catch{
          this.message=[];
        }
      }
    });
  }

  createXML(){
    this.documentsService.createXML(this.id_document).subscribe((uri)=>{
      //se c'è un errore nella creazione del file xml, mostro messaggio di errore e chiudo la finestra
      if (uri.error){
        console.log(uri);        
        this.close();
        Globals.message.showToaster("Errore nella creazione del file XML. Controlla il documento",ToastMode.DANGER);
      } else {     
        this.url_xml=uri;
        this.checkXML();
      }
    })
  }

  downloadPreview(){
    
    window.open(this.url,"_blank");
   
  }

  sendToSdi(){
    
    let ids=[];
    ids.push(this.id_document);
  
    Globals.modal.showConfirm("","Confermi di voler inviare il documento al Sistema di Interscambio?",()=>{      
      Globals.setLoading(true);
      this.documentsService.sendMultipleEInvoice(ids).subscribe((sended)=>{
        Globals.setLoading(false);
        //se sdi_status è diverso da 3, significa che l'invio è andato a buon fine
        if(sended.sdi_status!=3){          
          Globals.message.showToaster("Documento inviato correttamente a SdI",ToastMode.SUCCESS);
        } else {          
          Globals.message.showToaster("Errore nell'invio a SdI.",ToastMode.DANGER);
        }
        this.close();
      })
    },"Sì. Invia","No. Annulla");
  }


  uploadXML(){
    this.uploadXMLModalRef=this.modalService.open(this.uploadXMLModal);
  }
  
  closeUploadXMLModal(){
    this.uploadXMLModalRef.close();
  }

  confirmUploadXMLModal(){
    this.uploadService.uploadFile(this.fileXMLToUpload,"documents",(result)=>{
      //Solo se estensione è corretta
      if(result.split(".")[1]=="xml" && result.split(".")[2]=="p7m"){
        Globals.setLoading(true);
         this.documentsService.sendXMLFile(result,this.id_document).subscribe((sended)=>{
            if(sended){
             Globals.setLoading(false);
             Globals.message.showToaster("File inviato correttamente a SdI",ToastMode.SUCCESS);
            }
         })
                
      }else{
        //msg di errore        
        Globals.message.showToaster('Estensione del file non valida\n(estensione corretta: .xml.p7m).',ToastMode.DANGER);
      }
     
    },false);
    this.closeUploadXMLModal();
  }

    
  handleFileXMLInput(files: FileList) {
      this.fileXMLToUpload = files.item(0);   
  }

  

}



@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
} 